// frontend/src/components/CRSFormSections/AdditionalPointsSection.js
import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography
} from '@mui/material';
import {
  BAD_VALUE,
  yesNoOptions,
  jobOfferNocOptions
} from '../../constants/crsFormOptions'; // Adjust path as needed

function AdditionalPointsSection({ formData, handleChange, handleFocus, showJobOfferNoc }) {
  return (
    <Box sx={{ display: 'grid', gap: 2 }}>
      <Typography variant="h6" sx={{ mt: 2 }}>Additional Points</Typography>

      {/* Certificate of Qualification */}
      <FormControl fullWidth required>
        <InputLabel id="certificate-label">7. Do you have a certificate of qualification from a Canadian province, territory or federal body?</InputLabel>
        <Select
          labelId="certificate-label"
          name="hasCertificateOfQualification"
          value={formData.hasCertificateOfQualification}
          label="7. Do you have a certificate of qualification from a Canadian province, territory or federal body?"
          onChange={handleChange}
          onFocus={() => handleFocus('hasCertificateOfQualification')}
        >
          {yesNoOptions.map(option => (
            <MenuItem key={option.value} value={option.value} disabled={option.value === BAD_VALUE}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Job Offer */}
      <FormControl fullWidth required>
        <InputLabel id="job-offer-label">8. Do you have a valid job offer supported by a Labour Market Impact Assessment (LMIA)?</InputLabel>
        <Select
          labelId="job-offer-label"
          name="hasValidJobOffer"
          value={formData.hasValidJobOffer}
          label="8. Do you have a valid job offer supported by a Labour Market Impact Assessment (LMIA)?"
          onChange={handleChange}
          onFocus={() => handleFocus('hasValidJobOffer')}
        >
          {yesNoOptions.map(option => (
            <MenuItem key={option.value} value={option.value} disabled={option.value === BAD_VALUE}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Job Offer NOC (Conditional) */}
      {showJobOfferNoc && (
        <FormControl fullWidth required>
          <InputLabel id="job-offer-noc-label">8a. Which NOC TEER is the job offer?</InputLabel>
          <Select
            labelId="job-offer-noc-label"
            name="jobOfferNocTeer"
            value={formData.jobOfferNocTeer}
            label="8a. Which NOC TEER is the job offer?"
            onChange={handleChange}
            onFocus={() => handleFocus('jobOfferNocTeer')}
          >
            {jobOfferNocOptions.map(option => (
              <MenuItem key={option.value} value={option.value} disabled={option.value === BAD_VALUE}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {/* Provincial Nomination */}
      <FormControl fullWidth required>
        <InputLabel id="nomination-label">9. Do you have a nomination certificate from a province or territory?</InputLabel>
        <Select
          labelId="nomination-label"
          name="hasProvincialNomination"
          value={formData.hasProvincialNomination}
          label="9. Do you have a nomination certificate from a province or territory?"
          onChange={handleChange}
          onFocus={() => handleFocus('hasProvincialNomination')}
        >
          {yesNoOptions.map(option => (
            <MenuItem key={option.value} value={option.value} disabled={option.value === BAD_VALUE}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Sibling in Canada */}
      <FormControl fullWidth required>
        <InputLabel id="sibling-label">10. Do you or your spouse/partner have a sibling in Canada (PR/Citizen)?</InputLabel>
        <Select
          labelId="sibling-label"
          name="hasSiblingInCanada"
          value={formData.hasSiblingInCanada}
          label="10. Do you or your spouse/partner have a sibling in Canada (PR/Citizen)?"
          onChange={handleChange}
          onFocus={() => handleFocus('hasSiblingInCanada')}
        >
          {yesNoOptions.map(option => (
            <MenuItem key={option.value} value={option.value} disabled={option.value === BAD_VALUE}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export default AdditionalPointsSection;